var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFormFieldSpinnerDown = function SvgFormFieldSpinnerDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: 9,
    height: 9,
    viewBox: "0 0 8 5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3.2.7 0 0 .8l4 4 4-4-.8-.8z"
  })));
};
export default SvgFormFieldSpinnerDown;